import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class AnomalieGardiennageEvent extends UserEvent {
  public static NAME = 'ANOMALIE_GARDIENNAGE';

  constructor(
    public idVacation: string,
    public texte: string,
    public photos: string[],
    public avecZone: boolean,
    public idZone: string | undefined,
    instant?: dayjs.Dayjs,
    coordinates?: Coordinates
  ) {
    super(AnomalieGardiennageEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: AnomalieGardiennageEvent): AnomalieGardiennageEvent {
    return new AnomalieGardiennageEvent(obj.idVacation, obj.texte, obj.photos, obj.avecZone, obj.idZone, obj.instant, obj.coordinates);
  }
}
